export default {
  title: 'Utwórz źródło danych',
};
